import React, { useState } from "react";
import scientistImg from "../../assets/img/lab-person.png"; // replace with your image

const ContactForm = () => {
  const [form, setForm] = useState({
    name: "",
    phone: "",
    email: "",
    requirement: "",
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Form submitted:", form);
    setForm({ name: "", phone: "", email: "", requirement: "" });
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6 py-10 bg-brand">
      <div className="max-w-5xl w-full grid md:grid-cols-2 gap-10 items-center">
        {/* Left: Contact Form */}
        <div className="shadow-lg rounded-xl p-8 bg-gradient-to-r from-green-200 via-indigo-100 to-green-100">
          <h2 className="text-3xl font-bold text-gray-800 mb-1">
            Contact us
            <span className="text-sm font-normal text-gray-500 ml-1">
              (We will call you back!)
            </span>
          </h2>

          <form onSubmit={handleSubmit} className="mt-6 space-y-4">
            {/* Name */}
            <input
              type="text"
              name="name"
              value={form.name}
              onChange={handleChange}
              placeholder="Your Name"
              className="w-full px-4 py-3 border border-gray-300 rounded-full focus:outline-none focus:ring-2 focus:ring-blue-500"
              required
            />

            {/* Phone */}
            <input
              type="tel"
              name="phone"
              value={form.phone}
              onChange={handleChange}
              placeholder="Phone Number"
              className="w-full px-4 py-3 border border-gray-300 rounded-full focus:outline-none focus:ring-2 focus:ring-blue-500"
              required
            />

            {/* Email */}
            <input
              type="email"
              name="email"
              value={form.email}
              onChange={handleChange}
              placeholder="Email Address"
              className="w-full px-4 py-3 border border-gray-300 rounded-full focus:outline-none focus:ring-2 focus:ring-blue-500"
              required
            />

            {/* Requirement */}
            <textarea
              name="requirement"
              value={form.requirement}
              onChange={handleChange}
              placeholder="Additional detail about your Requirement"
              rows="4"
              className="w-full px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            ></textarea>

            {/* Submit */}
            <button
              type="submit"
              className="w-full bg-emerald-400 text-white font-semibold py-3 rounded-full hover:bg-emerald-500 transition"
            >
              Sent
            </button>
          </form>
        </div>

        {/* Right: Illustration */}
        <div className="flex justify-center">
          <img
            src={scientistImg}
            alt="Scientist Illustration"
            className="max-w-sm w-full"
          />
        </div>
      </div>
    </div>
  );
};

export default ContactForm;